<template>
  <div class="user-info">
    <div class="title">Account Details</div>
    <div class="info">
      <table cellpadding="0" cellspacing="0" style="width:100%;height:180px;">
        <!-- Name -->
        <tr>
          <td><div class="dot name-dot"></div></td>
          <td class="label">Name</td>
          <td class="value" :title="$store.state.user.name">
            <a-spin size="small" :spinning="!$store.state.user.name">{{
              $store.state.user.name
            }}</a-spin>
          </td>
        </tr>
        <!-- Country -->
        <tr>
          <td><div class="dot country-dot"></div></td>
          <td class="label">Country</td>
          <td class="value">
            <a-spin size="small" :spinning="!$store.state.user.country">{{
              $store.state.user.country
            }}</a-spin>
          </td>
        </tr>
        <!-- LoginEmail -->
        <tr>
          <td><div class="dot email-dot"></div></td>
          <td class="label">Login Email</td>
          <td class="value" :title="$store.state.user.loginEmail">
            <a-spin size="small" :spinning="!$store.state.user.loginEmail">{{
              $store.state.user.loginEmail
            }}</a-spin>
          </td>
        </tr>
        <!-- Password -->
        <tr>
          <td><div class="dot password-dot"></div></td>
          <td class="label">Password</td>
          <td class="value">
            ******
            <span>
              <FormOutlined
                style="font-size: 16px;margin-left: 20px;"
                @click="resetPassword"
              />
            </span>
          </td>
        </tr>
      </table>
    </div>
    <ResetPasswordModal ref="resetPasswordModal"></ResetPasswordModal>
  </div>
</template>

<script>
import { FormOutlined } from '@ant-design/icons-vue'
import ResetPasswordModal from './ResetPasswordModal'

export default {
  name: 'UserInfo',
  components: { FormOutlined, ResetPasswordModal },
  methods: {
    resetPassword() {
      this.$refs.resetPasswordModal.showModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.user-info {
  // width: 320px;
  height: 100%;
  padding: 20px;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;

  .title {
    font-size: 20px;
  }

  .info {
    background-color: #f3f6f9;

    table {
      margin-top: 10px;
      tr {
        height: 40px;

        td:first-child {
          width: 28px;
        }
      }
    }

    .dot {
      width: 8px;
      height: 8px;
      border-radius: 8px;
      margin: auto 10px;
    }

    .name-dot {
      background-image: linear-gradient(to left, #a0dbf2, #26ade1);
    }

    .country-dot {
      background-image: linear-gradient(to left, #c9c9ff, #9091ff);
    }

    .email-dot {
      background-image: linear-gradient(to left, #ffaeae, #ff5353);
    }

    .password-dot {
      background-image: linear-gradient(to left, #ffb765, #ff8a89);
    }

    .label {
      color: #333;
      min-width: 80px;
    }

    .value {
      color: #666;
    }
  }
}
</style>

<style lang="scss">
.user-info {
  .info {
    .value {
      .ant-spin-container {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
